<template>
  <div id="yarnType" class="q-pa-md">
    <el-row>
      <el-button id="addBtn" type="primary" @click="toAddCustomer">新增胚纱类型</el-button>
    </el-row>

    <el-table
      :data="tableData.slice((queryForm.pageNum-1)*queryForm.pageSize,queryForm.pageNum*queryForm.pageSize)"
      style="width: 80%"
      :default-sort="{prop: 'date', order: 'descending'}"
      border
    >
      <el-table-column prop="typeName" label="类型" sortable></el-table-column>
      <el-table-column prop="shortName" label="简称" sortable></el-table-column>
      <el-table-column prop="weight" label="序号"></el-table-column>
      <el-table-column label="操作" width="160">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">修改</el-button>
          <el-button size="mini" type="danger" @click="removeType(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page.sync="queryForm.pageNum"
      :page-size.sync="queryForm.pageSize"
      :page-sizes="[10,20,30,40,50]"
      :total="tableData.length"
      layout="total,sizes, prev, pager, next"
    ></el-pagination>

    <el-dialog title="添加类型" :visible.sync="dialogFormVisible" :width="dialogWidth">
      <el-form :model="form">
        <el-form-item label="类型" :label-width="formLabelWidth">
          <el-input v-model="form.typeName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="简称" :label-width="formLabelWidth">
          <el-input v-model="form.shortName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="序号" :label-width="formLabelWidth">
          <el-input v-model="form.weight" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveType">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="更新类型" :visible.sync="updateFormVisible" :width="dialogWidth">
      <el-form :model="updateForm">
        <el-form-item label="类型" :label-width="formLabelWidth">
          <el-input v-model="updateForm.typeName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="简称" :label-width="formLabelWidth">
          <el-input v-model="updateForm.shortName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="序号" :label-width="formLabelWidth">
          <el-input v-model="updateForm.weight" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateType">更 新</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      updateFormVisible: false,
      dialogFormVisible: false,
      form: {},
      updateForm: {},
      formLabelWidth: "120px",
      dialogWidth: "600px",
      queryForm: {pageSize:10}
    };
  },
  methods: {
    formatter(row) {
      return row.address;
    },
    toAddCustomer() {
      // this.$router.push("/customer/add");
      this.dialogFormVisible = true;
    },
    query() {
      var self = this;
      this.$axios
        .get("public/yarnType/query", { params: self.queryForm })
        .then(function(response) {
          if (response.data.errorCode == "00000") {
            self.tableData = response.data.data;
          } else {
            self.$message.error(response.data.errorMsg);
          }
        });
    },
    saveType() {
      var self = this;
      this.$axios.post("yarnType/save", self.form).then(function(response) {
        if (response.data.errorCode == "00000") {
          self.dialogFormVisible = false;
          //清空表单
          self.form = {};
          self.$message({
            message: "保存成功",
            type: "success"
          });
          self.query();
        } else {
          self.$message.error(response.data.errorMsg);
        }
      });
    },
    removeType(row) {
      var self = this;

      this.$confirm("此操作将永久删除该条记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axios
            .delete("yarnType/remove/" + row.id)
            .then(function(response) {
              if (response.data.errorCode == "00000") {
                self.$message({
                  message: "删除成功",
                  type: "success"
                });
                self.query();
              } else {
                self.$message.error(response.data.errorMsg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    handleEdit(index, row) {
      console.log(JSON.stringify(row));
      this.updateForm = JSON.parse(JSON.stringify(row));
      this.updateFormVisible = true;
    },
    updateType() {
      var self = this;
      this.$axios
        .post("yarnType/update", self.updateForm)
        .then(function(response) {
          if (response.data.errorCode == "00000") {
            self.updateFormVisible = false;
            self.$message({
              message: "更新成功",
              type: "success"
            });
            self.query();
          } else {
            self.$message.error(response.data.errorMsg);
          }
        });
    }
  },
  created: function() {
    console.log("yarnType created");
    this.query();
  }
};
</script>

<style scoped>
#addBtn {
  float: right;
}
#queryForm {
  margin-top: 20px;
  margin-bottom: 20px;
}
.el-table {
  margin:auto;
  margin-top: 40px;
  margin-bottom: 20px;
  width: 90%;
}
</style>